/**
 * Get the value at a given path from a given object. Returns undefined if the path doesn't exist.
 * @param path Path to the property
 * @param o Object to traverse
 * @param defaultValue Value to return if the key is not found
 */
export function getValueFromPath(path, o, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    // Create a path array if a string was given
    if (typeof path === 'string') {
        path = path.split('.');
    }
    return path.reduce(function (a, b) { return (a != null && a[b] !== undefined ? a[b] : defaultValue); }, o);
}
//# sourceMappingURL=get-value-from-path.js.map